exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".top-bar{background:#f3f3f4;height:55px;border-bottom:1px solid #e7eaec}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./client/app/common/top-bar/top-bar.scss
// module id = 487
// module chunks = 0